const {
    CLOUDINARY_PREFIX,
    TRANSFORMATION_S1,
    TRANSFORMATION_S2,
    TRANSFORMATION_L1,
    TRANSFORMATION_L2,
    TRANSFORMATION_M1,
    TRANSFORMATION_M2,
    TRANSFORMATION_XL
} = require('../constants');

const getSrcSet = (firstTransformation, secondTransformation, banner) =>
    `${CLOUDINARY_PREFIX}${firstTransformation}/${banner} 1x, `
    + `${CLOUDINARY_PREFIX}${secondTransformation}/${banner} 2x`;

const getCategoryPicture = (banner) => {
    const picture = [{
        media: '(min-width: 1260px)',
        srcSet: getSrcSet(TRANSFORMATION_XL, TRANSFORMATION_XL, banner)
    }, {
        media: '(min-width: 1025px)',
        srcSet: getSrcSet(TRANSFORMATION_L1, TRANSFORMATION_L2, banner)
    }, {
        media: '(max-width: 1024px)',
        srcSet: getSrcSet(TRANSFORMATION_M1, TRANSFORMATION_M2, banner)
    }];

    return {
        picture,
        src: getSrcSet(TRANSFORMATION_S1, TRANSFORMATION_S2, banner)
    };
};

module.exports = {
    getCategoryPicture
};
